import directApiClient from '../utils/directApiClient';

export const getOrganizationSubscription = async (organizationId) => {
	try {
		const response = await directApiClient.get(
			`/api/subscriptions/organization/${organizationId}`
		);

		return response.data;
	} catch (error) {
		console.error(
			'Error directly fetching organization subscription:',
			error
		);
		throw new Error(
			'Failed to retrieve organization subscription directly'
		);
	}
};
